if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
             
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            console.log('avatarrrrundown',response.quantity)
            let itemtxt =  Number(response.quantity) > 1 ? 'Items' : 'item';
            response.sections['cart-icon-bubble'] = '<div id="shopify-section-cart-icon-bubble" class="shopify-section"><a href="/cart" class="ctaaprod header__icon header__icon--cart link link--text focus-inset" id="cart-icon-bubble" role="button" aria-haspopup="dialog"><svg class="icon icon-cart" width="22" height="23" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">			<path d="M0.537476 1.03751H2.03748L4.03248 10.3525C4.10566 10.6937 4.29548 10.9986 4.56926 11.2149C4.84304 11.4312 5.18366 11.5453 5.53248 11.5375H12.8675C13.2089 11.537 13.5398 11.42 13.8057 11.2059C14.0717 10.9918 14.2566 10.6934 14.33 10.36L15.5675 4.78751H2.83998M5.74998 15.25C5.74998 15.6642 5.41419 16 4.99998 16C4.58576 16 4.24998 15.6642 4.24998 15.25C4.24998 14.8358 4.58576 14.5 4.99998 14.5C5.41419 14.5 5.74998 14.8358 5.74998 15.25ZM14 15.25C14 15.6642 13.6642 16 13.25 16C12.8358 16 12.5 15.6642 12.5 15.25C12.5 14.8358 12.8358 14.5 13.25 14.5C13.6642 14.5 14 14.8358 14 15.25Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>			</svg> <span class="icon-text">Cart</span> <span> ('+response.quantity+') </span><div class="cart-count-bubble"><span aria-hidden="true" class="visually-hidden"> '+response.quantity+' </span><span class="visually-hidden"> '+response.quantity+'  '+itemtxt+'</span></div></a></div>';
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
